<template>
	<div v-show="show">
		<h3 class="center">{{ headerTitle }}</h3>
		<div class="client-logos">
			<div class="client" v-for="client in clients">
				<span v-if="client.file">
					<img :src="`/files-small/${client.file.small}`" :alt="client.name">
					<div class="client-details">
						<img :src="`/files-small/${client.file.small}`" :alt="client.name">
						<h3 class="title">{{ client['title_' . lang] || client.title_en }}</h3>
						<p>{{ client['description_' . lang ] || client.description_en }}</p>
						<p class="projects-label" v-if="client.projects.length > 0"><strong>{{ projects }}</strong></p>
						<div v-for="project in client.projects">
							<a class="project-link" :href="`/${lang}/projects/${project['slug_hu']}`"><i class="ion-arrow-right-c"></i> {{ getProjectTitle(project) }}</a>
						</div>
					</div>
				</span>
			</div>
		</div>
		<div class="map-canvas" ref="canvas">
			<div v-for="client in clients"
				class="marker"
				:class="{ active: activeClient === client.id }"
				:style="`left: ${client.x}%;top: ${client.y}%;`"
				@mouseover="mouseOverHandle(client)"
				@mouseout="mouseOutHandle">
				<i class="ion-ios-location"></i>
				<div class="info" :class="infoboxClass">
					<div v-if="client.file" class="image" :style="`background-image: url('/files-small/${client.file.small}');`"></div>
					<h3 class="title">{{ client['title_' . lang] || client.title_en }}</h3>
					<p>{{ client['description_' . lang ] || client.description_en }}</p>
					<p class="projects-label" v-if="client.projects.length > 0"><strong>{{ projects }}</strong></p>
					<div v-for="project in client.projects">
						<a class="project-link" :href="`/${lang}/projects/${project['slug_hu']}`"><i class="ion-arrow-right-c"></i> {{ getProjectTitle(project) }}</a>
					</div>

				</div>
			</div>
			<div class="marker" style="top: 30.4%;left: 52.2%;">
				<i class="ion-ios-location"></i>
				<div class="info">
					<h3 class="title">CÉH Headquarter</h3>
				</div>
			</div>
			<div v-show="activeClient"
				class="connection-line"
				:class="infoboxClass"
				:style="`
					width: ${connectionBox.width}px;
					height: ${connectionBox.width/10}px;
					transform: rotate(${rotate}deg);
				`">
			</div>
			<img class="world-map-background" ref="image" src="/img/world-map-lg-2.png">
		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex';
	import axios from 'axios';

	export default {
		beforeMount() {
			var pathVars = window.location.pathname.split('/');
			this.lang = pathVars.length > 1 ? pathVars[1] : 'en';
		},
		mounted() {
			axios.get('/pa/worldmap-clients').then(resp => {
				this.clients = resp.data;
			}, error => this.handleError({ statusText: error.message }));
			this.interval = setInterval(this.imageLoaded, 500);
		},
		computed: {
			top() { return +this.connectionBox.top; },
			left() { return +this.connectionBox.left; },
			right() { return 100 - +this.connectionBox.right; },
			bottom() { return 100 - +this.connectionBox.bottom; },
			rotate() { return this.connectionBox.rotate; },
			headerTitle() {
				switch(this.currentLanguage) {
					case 'hu':
						return 'Megrendelőink világszerte';
					case 'en':
						return 'Our clients worldwide';
					case 'de':
						return 'Unsere Kunden weltweit';
					case 'fr':
						return 'Nos clients dans le monde';
					default:
						return 'Our clients worldwide';
				}
			},
			projects() {
				switch(this.lang) {
					case 'hu':
						return 'Projektek';
						break;
					case 'de':
						return 'Projekte';
					default:
						return 'Projects';
				}
			}
		},
		methods: {
			...mapActions(['handleError']),
			imageLoaded() {
				if(this.$refs.image.height > 0) {
					this.show = true;
					clearInterval(this.interval);
				}
			},
			getProjectTitle(project) {
				var lang = this.lang.toLowerCase();
				switch(lang) {
					case 'hu':
						return project.title_hu || project.title_en;
						break;
					case 'de':
						return project.title_de || project.title_en;
						break;
					default:
						return project.title_en;
				}
			},
			getAngleDeg(a,b) {
				var angleRad = Math.atan(Math.abs(+a.y - +b.y) / Math.abs(+a.x-+b.x));
				var angleDeg = angleRad * 180 / Math.PI;
				
				return angleDeg;
			},
			percentageToPx(perc, axes) {
				return axes === 'x'
					? perc / 100 * this.$refs.canvas.getBoundingClientRect().width
					: perc / 100 * this.$refs.canvas.getBoundingClientRect().height;
			},
			mouseOverHandle(client) {

				var ceh = {
					y: 30.4,
					x: 52.2
				}

				this.connectionBox = {
					top: +ceh.y > +client.y ? +client.y : +ceh.y,
					left: +ceh.x > +client.x ? +client.x : +ceh.x,
					right: +ceh.x > +client.x ? +ceh.x : +client.x,
					bottom: +ceh.y > +client.y ? +ceh.y : +client.y
				}

				var x = Math.abs(+ceh.x - +client.x) / 100 * this.$refs.canvas.getBoundingClientRect().width;
				var y = Math.abs(+ceh.y - +client.y) / 100 * this.$refs.canvas.getBoundingClientRect().height;
				this.connectionBox.width = Math.sqrt(
					Math.pow(x, 2) +
					Math.pow(y, 2)
				);

				var a = {
					x: this.percentageToPx(+client.x, 'x'),
					y: this.percentageToPx(+client.y, 'y')
				}
				
				var b = {
					x: this.percentageToPx(+ceh.x, 'x'),
					y: this.percentageToPx(+ceh.y, 'y')
				}

				this.connectionBox.rotate = this.getAngleDeg(a, b);

				switch(true) {
					case +ceh.x < +client.x && +ceh.y > +client.y:
						this.infoboxClass = 'right';
						this.connectionBox.rotate = -this.connectionBox.rotate;
						// top right of ceh.
						break;
					case +ceh.x < +client.x && +ceh.y < +client.y:
						this.infoboxClass = 'right';
						// bottom right of ceh.
						break;
					case +ceh.x > +client.x && +ceh.y < +client.y:
						// bottom left of ceh.
						this.infoboxClass = 'left';
						this.connectionBox.rotate = 180 - this.connectionBox.rotate;
						break;
					case +ceh.x > +client.x && +ceh.y > +client.y:
						this.infoboxClass = 'left';
						this.connectionBox.rotate = 180 + this.connectionBox.rotate;
						// top left of ceh.
						break;
				}
				this.activeClient = client.id;
			},
			mouseOutHandle(client) {
				this.activeClient = false;
				this.infoboxClass = '';
			},
			clickHandle(client) {
				this.activeClient = this.activeClient === client.id ? false : client.id;
			}
		},
		data() {
			return {
				lang: 'en',
				interval: '',
				infoboxClass: '',
				activeClient: false,
				show: false,
				clients: [],
				currentLanguage: window.currentLocale,
				connectionBox: {
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				}
			}
		}
	}
</script>

<style lang="scss" scoped>

    @import "./../../sass/variables";

    .world-map-background {
    	margin-top: 70px;
    }

    .map-canvas {
    	max-width: 1600px;
    	margin: 0 auto;
    	z-index: 1;

    	&:hover {
    		z-index: 3;
    	}
    }

	.client-logos {
	    justify-content: center;
		margin: 0 auto -60px;
		flex-direction: row;
	    align-items: center;
		position: relative;
		flex-wrap: wrap;
		display: flex;
		z-index: 2;
		width: 80%;

		@media screen and (max-width: $mobile-max) {
			margin-bottom: 0;
		}

		img {
			transition: all 300ms;
		    filter: saturate(0);
			position: relative;
			margin: 10px auto;
			height: auto;
			z-index: 10;
		}

		.client {
			position: relative;
			cursor: pointer;
			padding: 20px;
			width: 140px;
			z-index: 1;

			&:hover {
				z-index: 2;

				img {
					transition: all 300ms;
				    filter: saturate(1);
				}

				.client-details {
					pointer-events: all;
					z-index: 9;
					opacity: 1;
				}
			}
		}

		.client-details {
			box-shadow: 0 0 20px -5px rgba(0,0,0,0.3);
			transform: translateX(-50%);
			background-color: #fff;
			pointer-events: none;
			border-radius: 10px;
			position: absolute;
			padding: 20px;
			opacity: 0;
			width: 150%;
			z-index: -1;
			left: 50%;
			top: 0;

			img {
				margin: 10px auto 20px;
				max-width: 66%;
				opacity: 0;
			}
		}
	}

	.connection-box {
		position: absolute;
		display: block;
		z-index: 10;
	}

	.connection-line {
		transform-origin: 0 0;
		position: absolute;
	    margin-top: 20px;
		display: block;
		z-index: 11;
		left: 52.2%;
		top: 30.4%;
		height: 0;
		width: 0;

		&.left {
			&:before,
			&:after {
				border-width: 0 0 3px 0;
			}
		}

		&:after {
			border-width: 3px 0 0 0;
			border-color: $orange;
			border-style: dashed;
			border-radius: 50%;
			position: absolute;
			display: block;
			height: 200%;
			content: '';
			width: 100%;
			top: -100%;
			left: 0;
		}

		&:before {
			border-color: rgba(255,255,255,1);
			border-width: 3px 0 0 0;
			border-style: dashed;
			border-radius: 50%;
			position: absolute;
			filter: blur(2px);
			display: block;
			height: 200%;
			content: '';
			width: 100%;
			top: -100%;
			left: 0;
		}
	}

	.marker {

		&.active,
		&:hover {
			z-index: 901;

			.ion-ios-location {
				color: $light-blue;
			}

			.info {
				transform: scale(1) translate(-50%, -100%);
				transition: all 300ms;
				opacity: 1;

				&:after {
					transition: all 300ms 200ms;
					top: 100%;
				}

				// &.left {
				// 	transform: scale(1) translate(-100%, -50%);
				// }

				// &.right {
				// 	transform: scale(1) translate(0%, -50%);
				// }
			}
		}

		.info {
			transform: scale(0) translate(-50%, -90%);
			box-shadow: 0 10px 25px 0 rgba($blue, 1);
			background-color: #fff;
			transform-origin: 0 0;
			transition: all 300ms;
			border-radius: 6px;
			position: absolute;
			text-align: left;
			display: block;
			padding: 15px;
			z-index: 911;
			width: 250px;
			opacity: 0;
			top: -10px;
			left: 50%;

			* {
				position: relative;
				z-index: 1;
			}

			&:after {
				border-color: #fff transparent transparent transparent;
				border-style: solid;
				border-width: 10px;
				margin-left: -10px;
				position: absolute;
				display: block;
				content: '';
				z-index: 0;
				height: 0;
				left: 50%;
				width: 0;
				top: 50%;
			}

			.image {
				background-repeat: no-repeat;
				background-position: center;
				background-size: contain;
			    margin: 15px auto;
				display: block;
				height: 100px;
			    width: 80%;
			}
		}
	}

			a.project-link {
				text-overflow: ellipsis;
				text-decoration: none;
				font-weight: normal;
				white-space: nowrap;
				overflow: hidden;
				display: block;
				color: $black;

				i {
					color: $light-blue;
				}

				&:hover {
					color: $light-blue;
				}
			}

			.title {
				margin-bottom: 5px;
				font-weight: bold;
				line-height: 1.2;
				font-size: 16px;
			}

			.projects-label {
				line-height: 1.2;
				margin: 5px 0;
			}

</style>